const SIMPLE_VALIDATE_FIELD_TYPES = [
  "text",
  "number",
  "date",
  "textarea",
  "selectList",
  "company",
  "linha",
  "requester",
  "ddd"
];

function resolveSelectListPayload(field) {
  const fieldValue = field.value;

  if (fieldValue && typeof fieldValue === "object") {
    return {
      text: fieldValue.text ?? "",
      value: fieldValue.value ?? ""
    };
  }

  const option = (field.options || []).find(
    item => item.value === fieldValue || item === fieldValue
  );

  return {
    text: option?.text ?? "",
    value: fieldValue ?? ""
  };
}

function resolveDddPayload(field) {
  const selected = field.selected;

  if (!selected) {
    return null;
  }

  if (typeof selected === "object") {
    return {
      text: selected.text ?? selected.value ?? "",
      value: selected.value ?? selected.text ?? ""
    };
  }

  return {
    text: String(selected),
    value: String(selected)
  };
}

export function buildValidateFieldPayload(field) {
  if (!field || !field.type || !SIMPLE_VALIDATE_FIELD_TYPES.includes(field.type)) {
    return null;
  }

  switch (field.type) {
    case "text":
    case "number":
    case "date":
      return {
        text: field.value ?? "",
        value: field.value ?? "",
        model: field.name
      };

    case "textarea":
      return {
        text: field.label,
        value: field.value ?? "",
        model: field.name
      };

    case "selectList": {
      const { text, value } = resolveSelectListPayload(field);
      return {
        text,
        value,
        model: field.name
      };
    }

    case "company":
      return {
        text: field.label,
        value: String(field.selected ?? field.value ?? ""),
        model: field.name
      };

    case "linha":
      return {
        type: field.type,
        value: field.value ?? "",
        model: field.name
      };

    case "requester":
      return {
        text: field.text ?? "",
        value: field.value ?? "",
        model: field.type
      };

    case "ddd": {
      const dddPayload = resolveDddPayload(field);
      if (!dddPayload) {
        return null;
      }

      return {
        ...dddPayload,
        model: field.name
      };
    }

    default:
      return null;
  }
}

export { SIMPLE_VALIDATE_FIELD_TYPES };
